module.exports = __webpack_public_path__ + "static/media/extra-dino.08173d7f.png";